import type {AddCustomerOfferNoteFormPayload} from "./add-customer-offer-note.schema";
import {addCustomerOfferNote} from "@project/sdk/sales";
import {AddCustomerOfferNoteResponse} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";
import {customerOfferKeys, customerOfferMutationKeys} from "../../../../../customerOffer-keys";
import {addCustomerOfferNoteFormSchema} from "./add-customer-offer-note.schema";

export function addCustomerOfferNoteMutationOptions(id: string) {
  return mutationOptions({
    mutationKey: customerOfferMutationKeys.addCustomerOfferNote,
    mutationFn: async (payload: AddCustomerOfferNoteFormPayload) =>
      AddCustomerOfferNoteResponse.parse(
        await addCustomerOfferNote(id, addCustomerOfferNoteFormSchema.parse(payload)),
      ),
    onSuccess: async (_result, _variables, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: customerOfferKeys.detail(id)}),
        client.invalidateQueries({queryKey: customerOfferKeys.lists()}),
      ]);
    },
  });
}
